import React from 'react';

import { Skeleton } from '@mui/material';

import CommitForm from '../../../../../components/CommitForm';
import ContentCard from '../../../../../components/ContentCard';
import { useUpdateStudentMutation } from '../../../../../services/students';
import { Student } from '../../../../../services/students/types';
import { Metadata } from '../../../../../services/types';
import useError from '../../../../../utils/react/hooks/useError';

const STUDENT_STATE_FORM = {
  state: {
    xs: 12,
  },
};

interface StudentStateCardProps {
  student?: Student
  metadata?: Metadata
}

const StudentStateCard = ({ student, metadata } : StudentStateCardProps) => {
  const [updateStudent,
    { isLoading: isStudentUpdateLoading,
      isError: isStudentUpdateError,
      error: studentUpdateError }] = useUpdateStudentMutation();

  useError(isStudentUpdateError, studentUpdateError);

  if (!student) {
    return (
      <Skeleton variant="rectangular" height={128} />
    );
  }

  return (
    <ContentCard variant="contained" title="Student State">
      <CommitForm
        data={student}
        metadata={metadata}
        fields={STUDENT_STATE_FORM}
        onSubmit={async (values) => updateStudent({
          studentId: student.id,
          newAttributes: values,
        })}
        isSubmitLoading={isStudentUpdateLoading}
      />
    </ContentCard>
  );
};

export default StudentStateCard;
